export default {
  ID: 24,
  firstName: "رضا",
  lastName: "احمدی",
  email: "test@gmail.com",
  mobile: "09123456789",
  type: "real",
  category_id: "22",
  category: "ورزش و سلامتی",
  categoryID: 22,
  state: "تهران",
  city: "تهران",
  town: "تهران",
  postal_code: 1234567890,
  national_code: "1234567890",
  identity_number: "1234567890",
  phone: "02123456789",
  address:"تهران، حسن آباد، میدان حسن آباد، کوچه نعمتی، پلاک 20 واحد 8"
};
